import React from 'react'
import { Link } from 'react-router-dom'


const Navbar = (props) => {
  return (
    <>
    <div className='overflow-hidden'>
       <nav className="navbar navbar-expand-lg bg-dark navbar-dark">
        <div className="container-fluid">
            <Link className="navbar-brand" to="/">{props.title}</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/" target="_blank">Home</Link>
                </li>
                <li className="nav-item">
                <Link className="nav-link active" to="/about" target="_blank">About</Link>
                </li>
                <li className="nav-item"> 
                <Link className="nav-link active" to="/create-entry" target="_blank">Create-Entry</Link>
                </li>
            </ul>
            </div>
        </div>
       </nav>
    </div>
    </>
  )
}

export default Navbar